import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { selectLoggedAs } from "Selectors";
import { TTP_LOGO_URL } from "Config";
import Communities from "./Communities";
import Layouts from "./Layouts";
//import Hubs from "./Hubs";
import RightSide from "./RightSide";
import _ from "i18n";

import moment from "moment";
import "moment/locale/fr";
import "moment/locale/nl";
import "moment/locale/en-gb";

export class Menu extends Component {
  toggleSetting(e) {
    const menuLogo = document.getElementsByClassName("menu__logo").item(0)
      .classList;
    //const optionBtn = document.getElementsByClassName("toggleSetting").item(0).classList;
    const options = document.getElementsByClassName("setting-options").item(0)
      .classList;

    if (menuLogo.contains("display-settings")) {
      menuLogo.remove("display-settings");
      options.remove("show");
    } else {
      menuLogo.add("display-settings");
      options.add("show");
    }
  }

  hideSettingMenu = e => {
    const options = document.getElementsByClassName("setting-options");

    if (options && options.length > 0) {
      options.item(0).classList.remove("show");
    }

    document
      .getElementsByClassName("menu__logo")
      .item(0)
      .classList.remove("display-settings");
  };

  render() {
    const {
      lng,
      loggedAs,
      loggedAsPost,
      navCommunity,
      currentNavPage,
      currentPortal,
      isPublicPortal
    } = this.props;

    moment.locale(lng === "en" ? "en-gb" : lng);

    let headerClassName = "";
    if (currentNavPage === "COMMUNITY_PAGE") {
      headerClassName = "community-page";
    } else if (currentNavPage === "HOME_PAGE") {
      headerClassName = "home-page";
    }

    return (
      <header id="mainMenu" className={headerClassName}>
        <div className="top-bar" id="animated-menu">
          <span
            className="menu__logo"
            data-toggle="offCanvas"
            onMouseLeave={this.hideSettingMenu.bind(this)}
          >
            {loggedAs !== "GUEST" && loggedAs !== "EMPTY" ? (
              <div>
                <span
                  className="icon-options-vertical toggleSetting"
                  onClick={this.toggleSetting.bind(this)}
                />
                <ul className="setting-options">
                  {/* <li onClick={this.hideSettingMenu.bind(this)}>
                    <Link to="/settings">{_("Settings")}</Link>
                  </li> */}
                  {currentPortal === "COMMUNITY" &&
                  ["LEGAL_REPRESENTATIVE", "MANAGER"].includes(loggedAsPost) ? (
                    <li onClick={this.hideSettingMenu.bind(this)}>
                      <Link to="/manage-layout">{_("Layout")}</Link>
                    </li>
                  ) : null}
                  {currentPortal === "COMMUNITY" &&
                    ["LEGAL_REPRESENTATIVE", "MANAGER"].includes(
                      loggedAsPost
                    ) && (
                      <li onClick={this.hideSettingMenu.bind(this)}>
                        <Link to="/manage-public-portal">
                          {_("Public portal")}
                        </Link>
                      </li>
                    )}
                  {/*currentPortal === "COMMUNITY" &&
                  ["LEGAL_REPRESENTATIVE", "MANAGER"].includes(loggedAsPost) ? (
                    <li onClick={this.hideSettingMenu.bind(this)}>
                      <Link to="/manage-drawers">{_("Drawers")}</Link>
                    </li>
                  ) : null*/}
                </ul>
              </div>
            ) : null}
            <Link to="/">
              <img
                src={
                  isPublicPortal && navCommunity
                    ? navCommunity.avatarUrl
                    : TTP_LOGO_URL
                }
                alt="logo"
                style={{ width: "8rem", height: "auto" }}
              />
            </Link>
            {/*}<h2>{_("Portail")}</h2>*/}
          </span>
          {!isPublicPortal && loggedAs !== "GUEST" && loggedAs !== "EMPTY" ? (
            <nav className="top-bar-left">
              <ul className="menu">
                <Communities />
                {/*<Hubs />*/}
              </ul>
            </nav>
          ) : null}
          {loggedAs !== "GUEST" &&
          loggedAs !== "EMPTY" &&
          currentNavPage === "COMMUNITY_PAGE" ? (
            <Layouts />
          ) : null}
          {loggedAs ? <RightSide /> : null}
        </div>
      </header>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  currentPortal: state.auth.currentPortal,
  loggedAs: selectLoggedAs(state),
  loggedAsPost: state.auth.loggedAsPost,
  currentNavPage: state.params.currentNavPage,
  isPublicPortal: state.params.publicPortal.fetched,
  navCommunity: state.auth.navCommunity,
  lng: state.params.lng
});

export default connect(mapStateToProps)(Menu);



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js